import type { IconSvgObject } from './types';

const TextFirstlineLeftIcon: IconSvgObject = [
  ["path", { d: "M3 3.07825H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 9.07825H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 15.0782H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3 21.0782H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M19 2.07825H15C13.8954 2.07825 13 2.97368 13 4.07825V8.07825C13 9.18282 13.8954 10.0782 15 10.0782H19C20.1046 10.0782 21 9.18282 21 8.07825V4.07825C21 2.97368 20.1046 2.07825 19 2.07825Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default TextFirstlineLeftIcon;
